import { Component, ElementRef, EventEmitter, forwardRef, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { 
  SharedDataService,
  SuppliersService,
  LoggedUserService,
  DocumentStatut,
  DocumentsService,
  PS_Supplier_Purchase_Docs_Result,
  ChangeStatutParams,
  SimpleReponseResult, } from 'ngx-paf-common';
  import { saveAs } from '@progress/kendo-file-saver';
import { Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { HttpEventType } from '@angular/common/http';

import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  NG_VALIDATORS,
  Validator,
  AbstractControl,
  ValidationErrors
} from '@angular/forms';



@Component({
  selector: 'pilotage-doc-commercial',
  templateUrl: './pilotage-doc-commercial.component.html',
  styleUrls: ['./pilotage-doc-commercial.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PilotageDocCommercialComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => PilotageDocCommercialComponent),
      multi: true
    }
  ]
})
export class PilotageDocCommercialComponent
  implements OnInit, ControlValueAccessor, Validator {


  @Input() readonly:boolean;
  @Input() required?:boolean;
  @Output() docChanged:EventEmitter<PS_Supplier_Purchase_Docs_Result>=new EventEmitter<PS_Supplier_Purchase_Docs_Result>();
  

  doc:PS_Supplier_Purchase_Docs_Result = new PS_Supplier_Purchase_Docs_Result() ;
private onChange: (value: PS_Supplier_Purchase_Docs_Result) => void = () => {};
private onTouched: () => void = () => {};
private disabled = false;

writeValue(value: PS_Supplier_Purchase_Docs_Result): void {
  this.doc = value ?? new PS_Supplier_Purchase_Docs_Result();
  this._topFile = !this.docIsEmpty;
}

registerOnChange(fn: any): void {
  this.onChange = fn;
}

registerOnTouched(fn: any): void {
  this.onTouched = fn;
}

setDisabledState(isDisabled: boolean): void {
  this.disabled = isDisabled;
}

  lstDocStatuts:DocumentStatut[]=[];
  @ViewChild('fileUpload') fileUpload: ElementRef;
  private _topFile:boolean=true;
  get topFile():boolean {
    return this._topFile;
  }

  set topFile(value: boolean) {
    if (!value && (this.doc?.DocId || 0) > 0) {
      this.sharedDataSvc.confirm('Archiver le fichier existant?', () => {
        let params = new ChangeStatutParams();
        params.SupplierId = this.doc.SupplierId;
        params.documentId = this.doc.DocId;
        params.CurrentStatutId = this.doc?.StatutId;
        params.NewStatutId = this.lstDocStatuts.find(s => s.Cod == 'ARCHIVE').Id;
        this.documentsSvc.ChangeStatut(this.doc.SupplierId, params)
          .subscribe(res => {
            if (!res.Ok) {
              this.sharedDataSvc.alert(res.Message);
              return;
            }
            this.doc = new PS_Supplier_Purchase_Docs_Result();
            this._topFile = value;
            this.docChanged.emit(this.doc);
            this.onChange(this.doc);
            this.onTouched();
          });

      }, null);
      return;
    }
    this._topFile = value;
    if (!value) {
      this.doc = new PS_Supplier_Purchase_Docs_Result();
      this.docChanged.emit(this.doc);
      this.onChange(this.doc);
      this.onTouched();
    }
  }


  btnArchiveFile():void {
    this.topFile = false;
  }

  constructor(
    public sharedDataSvc:SharedDataService,
    private suppliersSvc:SuppliersService,
    private loggedUserSvc:LoggedUserService,
    private documentsSvc: DocumentsService
    ) { }

  ngOnInit(): void {
    this.documentsSvc.getDocumentStatuts().subscribe(res=>{
      this.lstDocStatuts=res;
    });
  }
  get docIsEmpty():boolean {
    return (this.doc?.FullPath || '')=='';
  }

  
  btnDownloadFileClick(): void {
    this.documentsSvc.downloadFile(this.doc.SupplierId, this.doc?.DocId)
      .subscribe(blob => {
        saveAs(blob, this.getFilename);
      });
  }
  
  get getFilename(): string {
    if (!this.docIsEmpty) return '';
    return this.doc?.FullPath.replace(/^.*[\\\/]/, '');
  }


  public get requiredFileType() : string {
    return this.sharedDataSvc.allowedExtensions.join(',');
  }
  isSizeAllowed(file: File): boolean{
    return file.size<=this.sharedDataSvc.maxFileSize;
  }
  iSExtensionAllowed(filename:string):boolean{
    let ext= ('.'+ filename.split('.')[filename.split('.').length-1]).toUpperCase();
    return this.sharedDataSvc.allowedExtensions.some(e=>e==ext);
  }
  
  uploadProgress: number = null;
  uploadSub: Subscription;
  
  reset() {
    this.uploadProgress = null;
    this.uploadSub = null;

    this.docChanged.emit(this.doc);
    this.onChange(this.doc);
    this.onTouched();
  }



  private fileIsDropping: boolean = false;

  onFilesDropped(event:any):void{
    let files:FileList=<FileList>event;
    const file: File = files[0];
    if (file) {
      if (!this.iSExtensionAllowed(file.name)) {
        this.sharedDataSvc.pafAlert('Extension_non_autorisee');
        this.fileUpload.nativeElement.value = "";
          return;
      }
      if (!this.isSizeAllowed(file)) {
          this.sharedDataSvc.pafAlert('Fichier_trop_volumineux');
          this.fileUpload.nativeElement.value = "";
          return;
      }
      
      if ((this.doc.Description||'').trim().length<3){
        this.sharedDataSvc.pafAlert('Precisez_la_description_du_document');
        this.fileUpload.nativeElement.value = "";
        return;
      }

      if (this.fileIsDropping) {
        this.sharedDataSvc.pafAlert('Fichier_en_cours_d_import');
        this.fileUpload.nativeElement.value = "";
        return;
      }
      this.doc.FullPath = file.name;
      const formData = new FormData();
      //formData.append("regulDocFile", file);
      formData.append(this.doc.Screen, file);
      formData.append("description",this.doc.Description);
      const upload$ = this.documentsSvc.uploadPurchaseFile(this.doc, formData)
        .pipe(
          finalize(() => {
            this.fileIsDropping = false;
            this.reset();
          })
        );

      this.fileIsDropping = true;
      this.uploadSub = upload$.subscribe(event => {
        if (event.type == HttpEventType.UploadProgress) {
          this.uploadProgress = Math.round(100 * (event.loaded / event.total));
        }
      });
    }
  }
  
 
  
  onFileSelected(event: any) {
    this.onFilesDropped( event.target.files);
  }

  get fileName():string{
    if ((this.doc?.FullPath||'')=='') return '';
    const  tmp:string[] = this.doc?.FullPath.split('\\');
    return  (tmp.length==0) ? '' : tmp[tmp.length-1];
  }

  
  validate(control: AbstractControl): ValidationErrors | null {
    if (this.required && this.docIsEmpty) {
      return { required: true };
    }
    if (this.uploadProgress !== null) {
      return { uploading: true };
    }
    return null;
  }

  get showUploadButton():boolean {
    return this.docIsEmpty && !this.readonly && this.uploadProgress==null;
  }
}